
      import FontUnberline from './font-unberline.vue'
      import type { App, Plugin } from 'vue'

      export const FontUnberlinePlugin: Plugin = {
        install(app: App) {
          app.component('FontUnberline', FontUnberline)
        },
      }
      export { FontUnberline }
      